import React from 'react';
import { TICKET_STATUS_COLOR, TICKET_STATUS_LABEL, PRIORITY_COLOR, PRIORITY_LABEL } from '@/lib/labels';

export function StatusBadge({ status }) {
  const cls = TICKET_STATUS_COLOR[status] || 'bg-slate-100 text-slate-700 border-slate-200';
  const label = TICKET_STATUS_LABEL[status] || status;
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${cls}`}>{label}</span>
  );
}

export function PriorityBadge({ priority }) {
  const cls = PRIORITY_COLOR[priority] || 'bg-slate-100 text-slate-700 border-slate-200';
  const label = PRIORITY_LABEL[priority] || priority;
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${cls}`}>{label}</span>
  );
}

export function ActiveBadge({ active }) {
  return active ? (
    <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-700 border border-emerald-200">Ativo</span>
  ) : (
    <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-500 border border-slate-200">Inativo</span>
  );
}
